var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOverviewPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_OverviewPage",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM4.3,14.908a1,1,0,1,1,1-1A1,1,0,0,1,4.3,14.908Zm0-4.492a1,1,0,1,1,1-1A1,1,0,0,1,4.3,10.416Zm0-4.479a1,1,0,1,1,1-1A1,1,0,0,1,4.3,5.937ZM16.01,14.35a.6.6,0,0,1-.6.6H7.224a.6.6,0,0,1-.6-.6v-.91a.6.6,0,0,1,.6-.6H15.41a.6.6,0,0,1,.6.6Zm0-4.479a.6.6,0,0,1-.6.6H7.224a.6.6,0,0,1-.6-.6v-.91a.6.6,0,0,1,.6-.6H15.41a.6.6,0,0,1,.6.6Zm0-4.479a.6.6,0,0,1-.6.6H7.224a.6.6,0,0,1-.6-.6v-.91a.6.6,0,0,1,.6-.6H15.41a.6.6,0,0,1,.6.6Z",
    fill: "#4f4f4f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverviewPage);
export default __webpack_public_path__ + "static/media/Icon_OverviewPage.1c57c6df4cf70cec061c00d9d40854b1.svg";
export { ForwardRef as ReactComponent };